module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_A_Concept01.b542d293.jpg";